import React from "react";

export const MenuRow = ({item, rowClass = '', isSubcategoryHeader = false}) => <div className={"row " + rowClass}>
    <div className={(isSubcategoryHeader ? "col-12" : "col-6") + " title"}>
        {item.title}
        {!item.description || item.description.length === 0 ? null : (<><br />
            <small>({item.description})</small></>)}

    </div>
    {isSubcategoryHeader ? null : <>
        <div className="col-2 exit">{rowClass.length !==0 ? item.exit : item.exit.split('/').join(' / ')}</div>
        <div className="col-2 price">{rowClass.length !==0 ? item.price : parseFloat(item.price) === 0 ? "-" : parseFloat(item.price)}</div>
    </>}
</div>